import { Constants } from "../constants";

const initialState = {
  creators: [],
  creator: {},
  payload: {},
  loadMore: false,
  filter: false
};

function globalReducer(state = initialState, action) {
  switch (action.type) {
    case Constants.GET_ALL_CREATORS_SUCCESS:
      return {
        ...state,
        creators: action.payload.data,
        payload: { ...action.payload },
        loadMore: action.payload.data.length >= 12 ? true : false
      };
    case Constants.GET_ALL_CREATORS_LOADMORE_SUCCESS:
      return {
        ...state,
        creators: state.creators.concat(action.payload.data),
        payload: { ...action.payload },
        loadMore: action.payload.data.length >= 12 ? true : false
      };
    case Constants.GET_USERDATA_SUCCESS:
    case Constants.CONTACTUS_SUCCESS:
    case Constants.RESET_PASS_EMAIL_SUCCESS:
      return {
        ...state,
        creator: { ...action.payload.data },
        payload: { ...action.payload }
      };
    case Constants.GET_ALL_CREATORS_FAILURE:
    case Constants.GET_USERDATA_FAILURE:
    case Constants.CONTACTUS_FAILURE:
    case Constants.RESET_PASS_EMAIL_FAILURE:
      return {
        ...state,
        payload: { ...action.payload }
      };
    case "FILTER_STATUS":
      return {
        ...state,
        filter: action.filter
      };
    default:
      return state;
  }
}

export default globalReducer;
